



















import { Component, Prop, Vue } from "vue-property-decorator";
import {AppealCustomFields} from "@/models/appeals";

@Component({})
class MoneyCustomField extends Vue {
  [x: string]: any;

  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) errorMessages: any;

  value = "";

  mounted() {
    this.value = this.item['значение'] || "";
  }

  setValue() {
    this.item['значение'] = (parseInt(this.value) / 100).toFixed(2);
    this.item['ошибка'] = "";
  }

  moneyRule() {
    if (this.required) {
      return [
        v => !!v || "Заполните данное поле",
      ];
    }
    return [];
  }
}

export default MoneyCustomField;
